import styled from '@emotion/styled';
import moment from 'moment';
import React, {useState} from 'react';
import {mixinFlexboxRow} from 'webapp-lib/styling';
import {useMountEffect} from 'webapp-lib/utils';

import {EventApiWithWorkLogProps} from '../../types';

const formatDuration = (totalSeconds: number) => {
  const milliseconds = moment
    .duration(totalSeconds, 'seconds')
    .asMilliseconds();
  return moment.utc(milliseconds).format('HH:mm:ss');
};

export const ElapsedTime = ({
  recordingEvent,
}: {
  recordingEvent: EventApiWithWorkLogProps;
}): React.ReactElement => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const startTime = moment(recordingEvent.start);

  const updateElapsedTime = () => {
    setElapsedSeconds(moment().diff(startTime, 'seconds'));
  };

  useMountEffect(() => {
    updateElapsedTime();
    const interval = setInterval(updateElapsedTime, 1_000);

    return () => clearInterval(interval);
  });

  return (
    <StyledElapsedTime>
      <div>Start {moment(recordingEvent.start).format('HH:mm')}</div>
      <div>{formatDuration(elapsedSeconds)}</div>
    </StyledElapsedTime>
  );
};

const StyledElapsedTime = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
  gap: var(--gutter-large);
`;
